import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const categoryImporterSelectors = importerSelectors(
  'category.importer',
);

export default categoryImporterSelectors;
